<template>
  <div class="container">
    <b-row>
      <div class="col-12">
        <table class="w-100">
          <tr>
            <td>
              <div class="ld-card-header">
                <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
                <img src="@/assets/images/logos/logo-hello.png" v-else style="max-height: 50px;">
              </div>
            </td>
            <td>
              <div  class="float-right noPrint">
                <b-btn variant="outline-primary" class="btn-xs" @click="$emit('print')" v-b-tooltip.hover title="Print"><b-icon icon="file-earmark-text" /></b-btn>
                <b-btn variant="outline-danger" class="btn-xs mx-2" @click="$emit('download')" v-b-tooltip.hover title="PDF"><b-icon icon="download" /></b-btn>
                <b-btn variant="outline-info" class="btn-xs" @click="$emit('closeModal')" v-b-tooltip.hover title="Close"><b-icon icon="x" /></b-btn>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  name: 'modalHeader',
  mixins: [authMixin]
}
</script>
